import { AxiosResponse } from 'axios';
import { Category } from 'src/admin-entity/interface/category/category.interface';
import { BASE_URL } from 'src/config/api';
import client from '../client';

export const getCategoryList = (): Promise<AxiosResponse<Category[]>> =>
    client.get(`${BASE_URL}/v1/admin/categories?withChildren=true`);

export const getCategoryDetail = (id: string): Promise<AxiosResponse<Category>> =>
    client.get(`${BASE_URL}/v1/admin/categories/${id}`);

export const getChildrenCategoryDetail = (id: string): Promise<AxiosResponse<Category[]>> =>
    client.get(`${BASE_URL}/v1/admin/categories/children/${id}`);

export const deleteCategory = (id: string): Promise<AxiosResponse<boolean>> =>
    client.delete(`${BASE_URL}/v1/admin/categories/${id}`);

export const createCategory = (category: Category): Promise<AxiosResponse<Category>> =>
    client.post(`${BASE_URL}/v1/admin/categories`, category);

export const createSubCategory = (category: Category): Promise<AxiosResponse<any>> =>
    client.post(`${BASE_URL}/v1/admin/categories`, category);

export const updateCategory = (category: Category): Promise<AxiosResponse<Category>> =>
    client.put(`${BASE_URL}/v1/admin/categories/${category.id}`, category);
